import { queryKeys } from "../queryKeys";
import { type AlgoRouting, getEliteAlgoRouting } from "../rest/elite";
import useRequest, { type QueryOptions } from "./useRequest";

type UseGetEliteAlgoRoutingArgs = {
  accountID: string;
  options?: QueryOptions<AlgoRouting>;
};

export const useGetEliteAlgoRouting = ({
  accountID,
  options,
}: UseGetEliteAlgoRoutingArgs) => {
  const { data } = useRequest(
    queryKeys.elite.algoRouting(accountID),
    () => getEliteAlgoRouting(accountID),
    {
      ...options,
      enabled: !!accountID && (options?.enabled ?? true),
    },
  );

  return { ...data };
};

export default useGetEliteAlgoRouting;
